var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramForeignCurrency64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./ForeignCurrency64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(6.000000, 8.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Yen-Coin",
    transform: "translate(0.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Focus",
    fill: "#FFCC00",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("g", {
    id: "F",
    transform: "translate(8.000000, 7.000000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,11 L0,11 C0.911884986,11 1.7374076,10.6391492 2.33483197,10.0562365 C2.93225634,9.47332372 3.30209048,8.66785328 3.30209048,7.77811824 C3.30209048,6.8883832 2.93225634,6.08291276 2.33483197,5.5 C1.7374076,4.91708724 1.36757347,4.1116168 1.36757347,3.22188176 C1.36757347,2.33214672 1.7374076,1.52667628 2.33483197,0.943267844 C2.93225634,0.360355083 3.75777896,3.01980663e-14 4.66966395,3.01980663e-14 C5.58154893,3.01980663e-14 6.40707155,0.360355083 7.00449592,0.943267844 C7.60192029,1.52667628 7.97175443,2.33214672 7.97175443,3.22188176",
    id: "Pound"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,6 L6,6",
    id: "Arm"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Pound-coin",
    transform: "translate(13.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\xA5",
    transform: "translate(9.000000, 6.384615)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,11.6153846 L4,4.61538462",
    id: "Arm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,6.61538462 L6,6.61538462",
    id: "Stem-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,9.61538462 L6,9.61538462",
    id: "Stem-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "V",
    points: "8 0.615384615 4 4.61538462 0 0.615384615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Euro-coin",
    transform: "translate(26.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("g", {
    id: "Euro",
    transform: "translate(9.000000, 8.000000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4 L4,4",
    id: "Stem-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7 L4,7",
    id: "Stem-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,11 L4.49804688,11 C2.56505025,11 0.99206543,9.74799151 0.99206543,8 L1,3 C1,1.25136255 2.56849523,-2.10942375e-14 4.49755859,-2.10942375e-14 L6,-2.10942375e-14",
    id: "Arm"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramForeignCurrency64);
export default __webpack_public_path__ + "static/media/pictogramForeignCurrency64.5599ed61a262e96bf5ee93f0dc093f7d.svg";
export { ForwardRef as ReactComponent };